import React from "react";
import ReactDOM from "react-dom/client"; // React 18 ke liye yeh import karein
import App from "./App";
// import "./styles.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);